import type { ErrorCopy } from '@shared/errors/catalog';

import { financeErrors } from '../_shared/errors';

/**
 * The codes this surface meets: the service's own set, plus the one refusal that
 * belongs to a plan specifically.
 *
 * The plan name is unique among live plans, so a second plan of the same name is
 * a `409` the operator can fix in the field they are already standing in — the
 * copy names that fix rather than the constraint.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = {
  ...financeErrors,
  FINANCE_PLAN_NOT_AVAILABLE: {
    message: 'هذه الخطّة لم تعد موجودة. أعد تحميل الصفحة.',
    tone: 'warning',
  },
};

/** The field-level messages, keyed on the `details[].code` the service returns. */
export const fieldErrors: Readonly<Record<string, string>> = {
  FINANCE_CONFLICT: 'اسم الخطّة مستخدم بالفعل. اختر اسماً آخر.',
};
